import script from "./CasesView.vue?vue&type=script&setup=true&lang=js"
export * from "./CasesView.vue?vue&type=script&setup=true&lang=js"

import "./CasesView.vue?vue&type=style&index=0&id=23dd74d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23dd74d6"]])

export default __exports__